import { z } from 'zod';

/** Search params of /o/$orgId/admin/members: the open tab (tabs are addressable, 13-ui-ux.md §1). */
export const MembersSearchSchema = z.object({
  tab: z.enum(['members', 'invitations']).optional().catch(undefined),
});
